export { default } from './useClickOutside';

export type { UseClickOutside } from './types';
